//PHONE NUMBERS
export const WHATS_APP_LINK = "555194141188";
export const WHATS_APP_TEXT = "51 9414 1188";
export const WHATS_FLORICULTURA_FK_LINK = "5551998443211";
export const WHATS_FLORICULTURA_MK_LINK = "5551998443211";
export const WHATS_APP_COMERCIAL_LINK =
  "https://api.whatsapp.com/send/?phone=555192166980&text=Ol%C3%A1%21+Quero+saber+mais+sobre+o+Plano+Assistencial+do+Grupo+Krause%21%0A%0ABV-5BVFG-6T6E528X&type=phone_number&app_absent=0";
export const WHATS_APP_COMERCIAL_TEXT = "51 9216 6980";
